<template>
  <div>
    <v-pagination
    v-model="v_currentPage"
    :page-count="totalPages"
    :classes="bootstrapPaginationClasses"
    @change="changePage">
    </v-pagination>
  </div>
</template>
<script>
import vPagination from 'vue-plain-pagination'

export default {
  name: 'CourseListPagination',
  components: {
    vPagination
  },
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    totalPages: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      v_currentPage: this.currentPage,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      }
    }
  },
  watch: {
    currentPage: function (newVal, oldVal) {
      this.v_currentPage = newVal
    }
  },
  methods: {
    changePage () {
      // console.log(this.v_currentPage);
      this.$emit('change-list-page', this.v_currentPage)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/clients/components/ClientsPagination.vue